import React from "react";
import { func, string } from "prop-types";
import Link from "../../Link";
import Image from "../../Image";

const LightBoxItem = ({ preview, full, openSlide }) => {
	return (
		<Link data-fslightbox href={full} onClick={e => openSlide(e, full)}>
			<Image src={preview} className="width-100" />
		</Link>
	);
};

LightBoxItem.propTypes = {
	preview: string.isRequired,
	full: string.isRequired,
	openSlide: func.isRequired,
};

export default LightBoxItem;
